import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import colors from '../Theme/colors';

const menuPropertyTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  onClick: PropTypes.func,
  tabIndex: PropTypes.number,
  focusable: PropTypes.bool,
};

type MenuProperties = PropTypes.InferProps<typeof menuPropertyTypes> & {
  fill?: string;
  width?: number;
  height?: number;
  className?: string;
  onClick?: () => void;
  tabIndex?: number;
  focusable?: boolean;
};

const Menu = (properties: MenuProperties) => (
  <Icon
    dPath="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
    title="Menu"
    fill={colors.greyDark}
    {...properties}
  />
);

Menu.propTypes = menuPropertyTypes;

export default Menu;
